<template>
	<button
		@click="togglePlayback"
	>
		<EwIcon
			v-if="!isLoading"
			:icon="isPlaying ? 'tabler:player-pause' : 'tabler:player-play'"
			class="cursor-pointer w-5 h-5 md:text-base mr-2"
		/>
		<div v-else class="spinner-player-btn w-5 h-5 mr-2"></div>
		<div v-if="displayType === 'list'">
			<span class="hidden md:inline">{{ labels.playlabel }}</span>
		</div>
		<div v-if="displayType === 'grid'">
			{{displayType}}
		</div>
	</button>
</template>

<script setup lang="ts">
import { ref, watch, onBeforeUnmount, defineProps, defineEmits } from 'vue';
import { messages } from '@/assets/language';
import { useAppStore } from '@/stores/app-store'


const { currentLng } = useAppStore()
const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
});

const displayType = ref<"list" | "grid">( "list" );

const props = defineProps<{
	file_url?: string;
	isPlaying?: boolean;
	language?: string;
}>();

const emit = defineEmits(['togglePlayback']);

//@ts-ignore

const sound = ref<Howl | null>(null);
const isLoading = ref(false);

const initAudio = () => {
	isLoading.value = true;
	//@ts-ignore
	sound.value = new Howl({
		src: [props.file_url],
		preload: true,
		volume: 0.5,
		onplay: () => {},
		onpause: () => {},
		onend: () => {
			emit('togglePlayback');
		},
		onload: () => {
			isLoading.value = false; // Ndalon ngarkimi kur është i ngarkuar
		},
		onloaderror: () => {
			isLoading.value = false; // Ndalon ngarkimi në rast të gabimit
		},
		onplayerror: () => {
			isLoading.value = false; // Ndalon ngarkimi në rast të gabimit
		},
	});
};
watch(
	() => props.file_url,
	() => {
		if (sound.value) {
			sound.value.stop();
			sound.value.unload(); // Howler cleanup
			sound.value = null;
		}
		isLoading.value = false;
		forceStop();
	}
);

watch(
	() => props.isPlaying,
	(newValue) => {
		if (newValue) {
			if (!sound.value) {
				initAudio();
			}
			sound.value?.play();
		} else {
			if (sound.value) {
				sound.value.pause();
				sound.value.seek(0); // Rikthe audio në fillim
			}
		}
	}
);
onMounted(() => {
    window.addEventListener("GLOBAL_STOP_AUDIO", forceStop)
})

onBeforeUnmount(() => {
    window.removeEventListener("GLOBAL_STOP_AUDIO", forceStop)
})

const forceStop = () => {
    if (sound.value) {
        sound.value.stop();
        sound.value.seek(0);
    }
    isLoading.value = false;
}

onBeforeUnmount(() => {
	if (sound.value) {
		sound.value.stop();
	}
});

const togglePlayback = () => {
	emit('togglePlayback');
	forceStop()
};
</script>
<style scoped>
.spinner-player-btn {
	border: 4px solid rgba(255, 255, 255, 0.1);
	border-left-color: #fff;
	border-radius: 50%;
	width: 1.25rem;
	height: 1.25rem;
	animation: spin 1s infinite linear;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}
</style>
